/* eslint-disable max-lines */
import {
    GoodsRuleOperateVo,
    CheckGoodsRuleOperateExistUsingGetParams,
    DeleteGoodsRuleOperateUsingGetParams,
    QueryGoodsRuleOperateDetailUsingGetParams,
    QuerySkuGoodsRuleOperateDetailUsingGetParams,
    QueryShopItemGoodsRuleOperateDetailUsingGetParams,
    GoGoodsRuleOperate,
    QuerySpuThirtySaleVo,
    ItemThirtySaleDataVo,
    QuerySkuThirtySaleVo,
    QueryShopItemThirtySaleVo,
    GoodsRuleOperateSummaryQueryVo,
    GoodsRuleOperateSummaryVo,
    RuleOperateItemParam,
    GoodsRuleOperateItemVo,
    ShopItemRuleOperateItemResult,
    RuleOperateLabelParam,
    RuleOperateLabelVo,
    EditRuleSortedVo,
    RuleOperateItemDetailParam,
    GoodsRuleOperateSpuItemDetailVo,
    GoodsRuleOperateSkuItemDetailVo,
    QueryShopSkuRuleItemUsingGetParams,
    ShopSkuRuleOperateItemResult,
    ListUsingGet2Params,
    GoodsExportDto,
    ExportRuleItemUsingGetParams,
    GoodsExportVo,
    ExportSkuRuleItemUsingGetParams,
    ExportShopRuleItemUsingGetParams,
    RuleTipsResult,
    GetRuleGoodsBySpuIdUsingGetParams,
    GoodsRuleOperateGoodsInfoVo,
    QuerySpuSaleUsingGetParams,
    GoodsSaleResult,
    QuerySkuSaleUsingGet1Params,
    CoIdAndSpuId,
    ExcludeGoodsParam,
    ExcludeGoodsResult,
    SpuRuleExtDataParam,
    SpuRuleExtDataResult,
    SkuRuleExtDataParam,
    SkuRuleExtDataResult,
    ShopItemRuleExtDataParam,
    ShopItemRuleExtDataResult,
} from '@servicesTypings/goodsRequest'

import { goodsRequest } from '@/utils/request'

import { GoodsOperationConfigVo } from '@servicesTypings/goodsRequestV3'

// 新增商品监控规则信息
/**
 * 新增商品监控规则信息
 */
export function addGoodsRuleOperate(data: GoodsRuleOperateVo): API.Res<string> {
    return goodsRequest.post('/goGoodsRuleOperate/addGoodsRuleOperate', { data })
}

// 新增商品监控规则信息[SKU]
/**
 * 新增商品监控规则信息
 */
export function addSkuGoodsRuleOperate(data: GoodsRuleOperateVo): API.Res<string> {
    return goodsRequest.post('/goGoodsRuleOperate/addSkuGoodsRuleOperate', { data })
}

// 新增商品监控规则信息[SHOP_ITEM]
/**
 * 新增店铺商品维度监控规则信息
 */
export function addShopItemGoodsRuleOperate(data: GoodsRuleOperateVo): API.Res<string> {
    return goodsRequest.post('/goGoodsRuleOperate/addShopItemGoodsRuleOperate', { data })
}

// 更新商品监控规则信息
/**
 * 更新商品监控规则信息
 */
export function updateGoodsRuleOperate(data: GoodsRuleOperateVo): API.Res<string> {
    return goodsRequest.post('/goGoodsRuleOperate/updateGoodsRuleOperate', { data })
}

// 更新商品监控规则信息[SKU]
/**
 * 更新商品监控规则信息
 */
export function updateSkuGoodsRuleOperate(data: GoodsRuleOperateVo): API.Res<string> {
    return goodsRequest.post('/goGoodsRuleOperate/updateSkuGoodsRuleOperate', { data })
}

// 更新商品监控规则信息[SHOP_ITEM]
/**
 * 更新店铺商品维度监控规则信息
 */
export function updateShopItemGoodsRuleOperate(data: GoodsRuleOperateVo): API.Res<string> {
    return goodsRequest.post('/goGoodsRuleOperate/updateShopItemGoodsRuleOperate', { data })
}

// 更新商品监控规则信息[SKU]
/**
 * 修改规则名称
 */
export function modifyRuleName(data: GoodsRuleOperateVo): API.Res<string> {
    return goodsRequest.post('/goGoodsRuleOperate/modifyRuleName', { data })
}

// 校验规则名称是否已存在
/**
 * 校验规则名称是否已存在
 */
export function checkGoodsRuleOperateExist(params: CheckGoodsRuleOperateExistUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/goGoodsRuleOperate/checkGoodsRuleOperateExist', { params })
}

// 删除商品监控规则
/**
 * 删除商品监控规则
 */
export function deleteGoodsRuleOperate(params: DeleteGoodsRuleOperateUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/goGoodsRuleOperate/deleteGoodsRuleOperate', { params })
}

// 批量删除商品监控规则
/**
 * 批量删除商品监控规则
 */
export function deleteGoodsRuleOperates(data: string[]): API.Res<number> {
    return goodsRequest.post('/goGoodsRuleOperate/deleteGoodsRuleOperates', { data })
}

// 查询商品监控规则明细
/**
 * 查询商品监控规则明细
 */
export function queryGoodsRuleOperateDetail(
    params: QueryGoodsRuleOperateDetailUsingGetParams,
): API.Res<GoodsRuleOperateVo> {
    return goodsRequest.get('/goGoodsRuleOperate/queryGoodsRuleOperateDetail', { params })
}

// 查询商品监控规则明细[SKU]
/**
 * 查询商品监控规则明细
 */
export function querySkuGoodsRuleOperateDetail(
    params: QuerySkuGoodsRuleOperateDetailUsingGetParams,
): API.Res<GoodsRuleOperateVo> {
    return goodsRequest.get('/goGoodsRuleOperate/querySkuGoodsRuleOperateDetail', { params })
}

// 查询商品监控规则明细[SHOP_ITEM]
/**
 * 查询店铺商品维度监控规则明细
 */
export function queryShopItemGoodsRuleOperateDetail(
    params: QueryShopItemGoodsRuleOperateDetailUsingGetParams,
): API.Res<GoodsRuleOperateVo> {
    return goodsRequest.get('/goGoodsRuleOperate/queryShopItemGoodsRuleOperateDetail', { params })
}

// 查询商品监控规则列表
/**
 * 查询商品监控规则列表
 */
export function queryGoodsRuleOperateList(): API.Res<GoGoodsRuleOperate[]> {
    return goodsRequest.get('/goGoodsRuleOperate/queryGoodsRuleOperateList')
}

// 查询款近30天销售数据
/**
 * 查询款近30天销售数据
 */
export function queryThirtyDaySaleBySpu(data: QuerySpuThirtySaleVo): API.Res<ItemThirtySaleDataVo> {
    return goodsRequest.post('/goodsThirtySale/queryThirtyDaySaleBySpu', { data })
}

// 查询sku近30天销售数据
/**
 * 查询sku近30天销售数据
 */
export function queryThirtyDaySaleBySku(data: QuerySkuThirtySaleVo): API.Res<ItemThirtySaleDataVo> {
    return goodsRequest.post('/goodsThirtySale/queryThirtyDaySaleBySku', { data })
}

// 查询商品链接近30天销售数据
/**
 * 查询商品链接近30天销售数据
 */
export function queryThirtyDaySaleByShopItem(data: QueryShopItemThirtySaleVo): API.Res<ItemThirtySaleDataVo> {
    return goodsRequest.post('/goodsThirtySale/queryThirtyDaySaleByShopItem', { data })
}

// 查询商品监控规则统计汇总信息列表
/**
 * 查询商品监控规则统计汇总信息列表
 */
export function queryGoodsRuleOperateSummaryList(
    data: GoodsRuleOperateSummaryQueryVo,
): API.Res<GoodsRuleOperateSummaryVo[]> {
    return goodsRequest.post('/goGoodsRuleOperate/queryGoodsRuleOperateSummaryList', { data })
}

// 查询商品监控规则统计汇总信息列表并排序
/**
 * 查询商品监控规则统计汇总信息列表并排序
 */
export function queryRuleOperateAndSort(data: GoodsRuleOperateSummaryQueryVo): API.Res<GoodsRuleOperateSummaryVo[]> {
    return goodsRequest.post('/goGoodsRuleOperate/queryRuleOperateAndSort', { data })
}

// 商品运营分析查询全部商品
/**
 * 查询SPU规则
 */
export function queryRuleItem(data: RuleOperateItemParam): API.Res<GoodsRuleOperateItemVo[]> {
    return goodsRequest.post('/goGoodsRuleOperateItem/querySpuRule', { data })
}

// 商品运营分析查询全部商品 [sku]
/**
 * 查询SkU规则
 */
export function querySkuRuleItem(data: RuleOperateItemParam): API.Res<GoodsRuleOperateItemVo[]> {
    return goodsRequest.post('/goGoodsRuleOperateItem/querySkuRule', { data })
}

// 商品运营分析查询全部商品 [SHOP_ITEM]
/**
 * 查询店铺链接规则
 */
export function queryShopItemRuleItem(data: RuleOperateItemParam): API.Res<ShopItemRuleOperateItemResult[]> {
    return goodsRequest.post('/goGoodsRuleOperateItem/queryShopItemRule', { data })
}

// 查询商家运营标签
/**
 * 查询商家运营标签
 */
export function pageRuleLabel(data: RuleOperateLabelParam): API.Res<RuleOperateLabelVo[]> {
    return goodsRequest.post('/goGoodsRuleOperateLabel/pageRuleLabel', { data })
}

// 设置置顶
/**
 * 更改规则置顶
 */
export function editRuleSorted(data: EditRuleSortedVo): API.Res<object> {
    return goodsRequest.post('/goGoodsRuleOperate/editRuleSorted', { data })
}

// 按款查看店铺维度
/**
 * 商品运营按sku的店铺销售统计数据列表
 */
export function querySpuRuleItemDetailByShop(
    data: RuleOperateItemDetailParam,
): API.Res<GoodsRuleOperateSpuItemDetailVo> {
    return goodsRequest.post('/goGoodsRuleOperateItem/querySpuRuleItemDetailByShop', { data })
}

// 按sku查看店铺维度
/**
 * 商品运营按spu的店铺销售统计数据列表
 */
export function querySkuRuleItemDetailByShop(
    data: RuleOperateItemDetailParam,
): API.Res<GoodsRuleOperateSkuItemDetailVo> {
    return goodsRequest.post('/goGoodsRuleOperateItem/querySkuRuleItemDetailByShop', { data })
}

// 按查看店铺SKU明细
/**
 * 店铺商品运营分析查询SKU明细
 */
export function queryShopSkuRuleItem(
    params: QueryShopSkuRuleItemUsingGetParams,
): API.Res<ShopSkuRuleOperateItemResult[]> {
    return goodsRequest.get('/goGoodsRuleOperateItem/queryShopSkuRuleItem', { params })
}

// 规则提示消息置为已读
/**
 * 规则提示消息置为已读
 */
export function ruleTipsStatusRead(data: EditRuleSortedVo): API.Res<object> {
    return goodsRequest.post('/goGoodsRuleOperate/ruleTipsStatusRead', { data })
}

// 新增不存在的标签
/**
 * 新增不存在的标签
 */
export function upsertRuleLabel(data: RuleOperateLabelParam): API.Res<RuleOperateLabelVo> {
    return goodsRequest.post('/goGoodsRuleOperateLabel/upsertRuleLabel', { data })
}

// 查询商品服务导出日志列表
/**
 * 查询商品服务导出日志列表
 */
export function goGoodsExport(params: ListUsingGet2Params): API.Res<GoodsExportDto[]> {
    return goodsRequest.get('/goods/goGoodsExport/list', { params })
}

// 商品运营分析导出全部商品
/**
 * 商品运营分析导出全部商品
 */
export function exportRuleItem(params: ExportRuleItemUsingGetParams): API.Res<GoodsExportVo> {
    return goodsRequest.get('/goGoodsRuleOperateItem/exportRuleItem', { params })
}

// 商品运营分析导出全部sku商品
/**
 * 商品运营分析导出全部sku商品
 */
export function exportSkuRuleItem(params: ExportSkuRuleItemUsingGetParams): API.Res<GoodsExportVo> {
    return goodsRequest.get('/goGoodsRuleOperateItem/exportSkuRuleItem', { params })
}

// 商品运营分析导出链接规则
/**
 * 商品运营分析导出链接规则
 */
export function exportShopRuleItem(params: ExportShopRuleItemUsingGetParams): API.Res<GoodsExportVo> {
    return goodsRequest.get('/goGoodsRuleOperateItem/exportShopRuleItem', { params })
}

// 查询规则提示结果
/**
 * 查询规则提示结果
 */
export function queryRuleTipsResult(): API.Res<RuleTipsResult> {
    return goodsRequest.get('/goGoodsRuleOperate/queryRuleTipsResult')
}

// 修改规则读取时间
/**
 * 修改规则读取时间
 */
export function modifyReadTime(data: EditRuleSortedVo): API.Res<object> {
    return goodsRequest.post('/goGoodsRuleOperate/modifyReadTime', { data })
}

// 根据商品id查询商品
/**
 * 根据商品id查询商品
 */
export function getRuleGoodsBySpuId(params: GetRuleGoodsBySpuIdUsingGetParams): API.Res<GoodsRuleOperateGoodsInfoVo> {
    return goodsRequest.get('/goGoodsRuleOperateItem/getRuleGoodsBySpuId', { params })
}

// 查询商品维度销量
/**
 * 查询商品维度销量
 */
export function querySpuSale(params: QuerySpuSaleUsingGetParams): API.Res<GoodsSaleResult> {
    return goodsRequest.get('/goodsThirtySale/querySpuSale', { params })
}

// 查询SKU维度销量
/**
 * 查询SKU维度销量
 */
export function querySkuSale(params: QuerySkuSaleUsingGet1Params): API.Res<GoodsSaleResult> {
    return goodsRequest.get('/goodsThirtySale/querySkuSale', { params })
}

// 根据商品编码获取缓存spuid
/**
 * 根据商品编码获取ERP直接上架缓存商品ID
 */
export function getCacheSpuIdByItemCode(data: string[]): API.Res<CoIdAndSpuId> {
    return goodsRequest.post('/erpDirectShelves/getCacheSpuIdByItemCode', { data })
}

// 查询规则数量
/**
 * 查询商品运营规则数量
 */
export function queryGoodsRuleCount(): API.Res<number> {
    return goodsRequest.get('/goGoodsRuleOperate/selectCount')
}

// 排除商品
/**
 * 排除商品
 */
export function excludeGoods(data: ExcludeGoodsParam): API.Res<ExcludeGoodsResult> {
    return goodsRequest.post('/goGoodsRuleOperateItem/excludeGoods', { data })
}

// 按款
/**
 * 查询不存在的商品ID
 */
export function queryNotExistSpuId(data: string[]): API.Res<string[]> {
    return goodsRequest.post('/goods/queryNotExistSpuId', { data })
}

// 按SKU
/**
 * 查询不存在的商品编码
 */
export function queryNotExistItemCode(data: string[]): API.Res<string[]> {
    return goodsRequest.post('/myself/rapidly/sku/queryNotExistItemCode', { data })
}

// 按链接
/**
 * 查询不存在的线上链接
 */
export function queryNotExistShopStyleCode(data: string[]): API.Res<string[]> {
    return goodsRequest.post('/shopManage/queryNotExistShopStyleCode', { data })
}

// 查询SPU规则扩展数据 [SPU]
/**
 * 查询SPU规则扩展数据
 */
export function querySpuRuleExtData(data: SpuRuleExtDataParam): API.Res<SpuRuleExtDataResult[]> {
    return goodsRequest.post('/goGoodsRuleOperateItem/querySpuRuleExtData', { data })
}

// 查询SKU规则扩展数据 [SKU]
/**
 * 查询SKU规则扩展数据
 */
export function querySkuRuleExtData(data: SkuRuleExtDataParam): API.Res<SkuRuleExtDataResult[]> {
    return goodsRequest.post('/goGoodsRuleOperateItem/querySkuRuleExtData', { data })
}

// 查询店铺链接规则扩展数据 [SHOP_ITEM]
/**
 * 查询店铺链接规则扩展数据
 */
export function queryShopItemRuleExtData(data: ShopItemRuleExtDataParam): API.Res<ShopItemRuleExtDataResult[]> {
    return goodsRequest.post('/goGoodsRuleOperateItem/queryShopItemRuleExtData', { data })
}

/**
 * 查询商家的商品运营个数限制
 */
export function queryGoodsOperationLimitUsingGET(): API.Res<number> {
    return goodsRequest.get('/goGoodsRuleOperate/queryGoodsOperationLimit')
}

/**
 * 查询商家的商品运营权益配置
 */
export function queryGoodsOperationConfig(): API.Res<GoodsOperationConfigVo> {
    return goodsRequest.get('/goGoodsRuleOperate/queryGoodsOperationConfig')
}
